module.exports = __webpack_public_path__ + "media/assets/services_manager/logos/oa_crm-ba5a45cdef4128317d5c680e65dac0b55d03a457f3b77589edcfe1d18feba58d.png";